<template>
  <nav
    :class="b()"
    aria-label="Breadcrumb"
  >
    <ul :class="b('list')">
      <li
        v-for="(item, index) in breadcrumbStore.items"
        :key="`breadcrumb--${index}`"
        :class="b('item', { active: item.active })"
      >
        <a
          :class="b('link')"
          :href="item.url"
          :title="item?.name ? $t('c-breadcrumb.link-title', { name: item.name }) : undefined"
          :aria-current="item.active ? 'page' : undefined"
        >
          {{ item.name }}
        </a>
        <span
          v-if="index !== breadcrumbStore.items.length - 1"
          :class="b('separator')"
          aria-hidden="true"
        >
          <e-icon
            icon="i-chevron--right"
            size="12"
          />
        </span>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import useBreadcrumbStore from '@/stores/breadcrumb';
  import eIcon from '@/elements/e-icon.vue';

  type Setup = {
    breadcrumbStore: ReturnType<typeof useBreadcrumbStore>;
  };
  // type Data = {};

  /**
   * Renders a list of breadcrumbs items from the store module.
   */
  export default defineComponent({
    name: 'c-breadcrumb',
    components: {
      eIcon,
    },

    // props: {},
    // emits: {},

    setup(): Setup {
      return {
        breadcrumbStore: useBreadcrumbStore(),
      };
    },
    // data(): Data {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use 'sass:map';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';

  .c-breadcrumb {
    $this: &;

    &__item {
      display: inline-flex;
      font-weight: variables.$va-font-weight--bold;
      align-items: center;
      flex-wrap: wrap;

      &--active {
        font-weight: variables.$va-font-weight--regular;
      }

      // For SSR.
      &:last-child #{$this}__separator {
        display: none;
      }
    }

    &__item:last-child {
      &::after {
        all: unset;
      }
    }

    &__link {
      @include mixins.hover-effect--default;

      color: inherit;
      text-decoration: none;
    }

    &__separator {
      margin: 0 0.3rem;

      .e-icon {
        height: 1rem;
      }
    }
  }
</style>
